import {Spinner} from 'react-bootstrap';
import React from 'react';
import {Slot} from '@radix-ui/react-slot';
import {Button, ButtonProps, buttonVariants} from 'components/ui/button';
import {cn} from 'utils/helpers';

export interface LoadingButtonProps extends ButtonProps {
  loading: boolean;
  hideChildrenWhenLoading?: boolean;
  contentAlignmentClassName?: string;
}

const LoadingButton = React.forwardRef<HTMLButtonElement, LoadingButtonProps>(
  (
    {
      className,
      variant,
      size,
      loading,
      children,
      style = {},
      hideChildrenWhenLoading = false,
      asChild = false,
      disabled = false,
      ...props
    },
    ref,
  ) => {
    const Comp = asChild ? Slot : Button;
    const isDisabled = loading || disabled;
    return (
      <Comp
        className={`${cn(buttonVariants({variant, size, className}))}${isDisabled ? ' cursor-not-allowed' : ''}`}
        style={{...style, pointerEvents: loading ? 'none' : 'auto'}}
        disabled={isDisabled}
        ref={ref}
        {...props}>
        {loading && (
          <div>
            <Spinner animation="border" size="sm" />
          </div>
        )}
        {hideChildrenWhenLoading && loading ? null : children}
      </Comp>
    );
  },
);
LoadingButton.displayName = 'LoadingButton';

export {LoadingButton};
